<app-objekt-basic-info [isModal]="true" [canAutoSave]="false">
</app-objekt-basic-info>
